export const MenuList = [
  {
    title: 'Home',
    path: '/'
  },
  {
    title: 'Night',
    path: '/category/night'
  },
  {
    title: 'Series',
    path: '/category/series'
  },
  {
    title: 'Barcelona',
    path: '/category/barcelona'
  },
  {
    title: 'landscape',
    path: '/category/landscape'
  },
  {
    title: 'vertical',
    path: '/category/vertical'
  },
  {
    title: '120',
    path: '/category/120'
  },
  // {
  //   title: 'About',
  //   path: '/about'
  // },
]
